const search_toggle_button = document.querySelector('.navigation__button--search');
const hamburger_toggle_button = document.querySelector('.navigation__button--menu-toggle');

// console.log( search_toggle_button );
// console.log( hamburger_toggle_button );

hamburger_toggle_button.addEventListener( 'click', ali_toggle_mega_menu );

function ali_toggle_mega_menu(e){
	try {
		document.documentElement.classList.remove('search--is-open');

		if( document.documentElement.classList.contains('nav--is-open') ){
			document.documentElement.classList.remove('nav--is-open');

		} else {
			document.documentElement.classList.add('nav--is-open');
		}
	}
	catch(error){
		console.log('Error toggling nav search:');
		console.log(error);
	}
}



search_toggle_button.addEventListener( 'click', ali_toggle_search_menu );

function ali_toggle_search_menu(e){
	try {
		document.documentElement.classList.remove('nav--is-open');

		if( document.documentElement.classList.contains('search--is-open') ){
			document.documentElement.classList.remove('search--is-open');

		} else {
			document.documentElement.classList.add('search--is-open');
			document.querySelector('.search-form__s').focus();
		}
	}
	catch(error){
		console.log('Error toggling nav search:');
		console.log(error);
	}
}
